import { createFileRoute } from '@tanstack/react-router'
import { OrganizationProfilePage } from '@/pages/profile/organization-profile/ui/OrganizationProfilePage'

export const Route = createFileRoute('/organization-profile')({
  component: OrganizationProfilePage,
})
